import { getLocationSearch } from './utils';

const UrlPilots = {
  emailMeV2: /(emailmev2=true|emailmev2=1)/,
  importFlow: /(importflow=true|importflow=1)/,
  liveChat: /(livechat=true|livechat=1)/,
  showLP: /(showlp=true|showlp=1)/,
};

const getIsUrlPilotEnabled = (key) => {
  const search = getLocationSearch();
  if (!search) {
    return false;
  }
  return !!search.toLowerCase().match(key);
};

export const getIsEmailMeEnabled = () => false;

export const getIsImportFlowEnabled = () => getIsUrlPilotEnabled(UrlPilots.importFlow);

export const getIsLiveChatEnabled = () => getIsUrlPilotEnabled(UrlPilots.liveChat);

export const getIsShowLPEnabled = () => getIsUrlPilotEnabled(UrlPilots.showLP);
